export const API_URL = 'https://api.quantumaxis.com.br/widgets/v1/'

export const API_SUBSCRIPTION_KEY = 'e0083ff1525545d790104c3aefd5288f'

export const GOOGLE_ANALYTICS_ID = ''

export const HOTJAR_ID = ''

export const HOTJAR_SNIPPET_VERSION = ''

export const HOME_TITLE = 'CNN Money'

export const THEME = 'cnn'

export const REDUX_PANE = false;
export const REDUX_LOGGER = false;
export const SHARE_URL = 'https://cnn.quantumfinance.com.br/';
export const APPLICATION_INSIGHTS_CONNECTION_STRING = 'InstrumentationKey=24413b36-11c2-436f-8a26-0505ec7c92a4;IngestionEndpoint=https://brazilsouth-0.in.applicationinsights.azure.com/'

